import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private _listeners = {};
  
  constructor() {  }

  registerSubject(type: string) {
    if (!this._listeners[type]) {
      this._listeners[type] = new Subject<any>();
    }
  }

  sendMessage(type: string, message: any) {
    this.registerSubject(type);
    this._listeners[type].next(message);
  }

  clearMessage(type: string) {
    this._listeners[type].next();
  }

  getMessage(type: string): Observable<any> {
    this.registerSubject(type);
    return this._listeners[type].asObservable();
  }

}